import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "long-arrow-right-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M23.0308 11.4696C23.3237 11.7625 23.3237 12.2374 23.0308 12.5303L18.0298 17.5313C17.7369 17.8242 17.2621 17.8242 16.9692 17.5313C16.6763 17.2384 16.6763 16.7635 16.9692 16.4706L20.6898 12.75H1.49948C1.08527 12.75 0.749481 12.4142 0.749481 12C0.749481 11.5858 1.08527 11.25 1.49948 11.25H20.6899L16.9692 7.52931C16.6763 7.23641 16.6763 6.76154 16.9692 6.46865C17.2621 6.17575 17.7369 6.17575 18.0298 6.46865L23.0308 11.4696Z" }, null, -1)
  ])))
}
export default { render: render }